import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TargetSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TargetSVG;
